import { render, staticRenderFns } from "./EditAppLimitButton.vue?vue&type=template&id=53b5bb52&"
import script from "./EditAppLimitButton.vue?vue&type=script&lang=js&"
export * from "./EditAppLimitButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports